import type {
  ContactSuggestionContact,
  ContactSuggestionResult,
} from '$contact-suggestions';

export function mapUserIntegrationContactSuggestionToContact(
  contactSuggestion: ContactSuggestionResult,
): ContactSuggestionContact {
  return {
    ...contactSuggestion.contactResponse,
    email: contactSuggestion.email,
    firstName: contactSuggestion.firstName,
    lastName: contactSuggestion.lastName,
  };
}
